// extracted by mini-css-extract-plugin
export var btn = "H_mY q_rJ q_rn d_bz d_bP d_bD d_dw";
export var full = "H_wz d_w d_H";
export var hoverStyle = "H_m1";
export var zoom = "H_m2";